module.exports = __webpack_public_path__ + "static/media/t3.32b4709d.jpg";